import { ActionPrompt } from './action-prompt';
import { AudioPlayer } from './audio';
import { EventEmitter } from './event-emitter';

export class LightSwitchScene extends EventEmitter {
	protected sceneElements = {
		background: document.querySelector('#light-switch-background') as any as HTMLImageElement,
		darkOverlay: document.querySelector('#light-switch-overlay') as any as HTMLImageElement,
		door: document.querySelector('#light-switch-door') as any as HTMLImageElement,
		lightBulb: {
			on: document.querySelector('.light-bulb.on') as any as HTMLImageElement,
			off: document.querySelector('.light-bulb') as any as HTMLImageElement,
			glow: document.querySelector('.light-bulb-glow') as any as HTMLImageElement,
		},
		lightSwitch: {
			on: document.querySelector('.light-switch.on') as any as HTMLImageElement,
			off: document.querySelector('.light-switch.off') as any as HTMLImageElement,
			helperOverlay: document.querySelector('.light-switch.helper-overlay') as any as HTMLImageElement,
		},
		sceneContainer: document.querySelector('#light-switch-scene-container') as HTMLElement,
		secondFlowerContainer: document.querySelector('.second-flower-container') as HTMLElement,
	};

	private audioPlayer = AudioPlayer.getInstance();
	private actionHelper = ActionPrompt.getInstance();

	private timeouts: any = [];

	public createElements(): void {
		this.sceneElements.darkOverlay.src = './static/images/light-switch-dark-overlay.png';
		this.sceneElements.lightBulb.on.src = './static/images/light-bulb-on.png';
		this.sceneElements.lightBulb.off.src = './static/images/light-bulb-off.png';
		this.sceneElements.lightBulb.glow.src = './static/images/light-bulb-glow.png';
		this.sceneElements.lightSwitch.on.src = './static/images/light-switch-on.png';
		this.sceneElements.lightSwitch.off.src = './static/images/light-switch-off.png';
		this.sceneElements.lightSwitch.helperOverlay.src = '../static/images/light-switch-white-overlay.png';
		this.sceneElements.door.src = './static/images/light-switch-door.png';
		this.sceneElements.background.src = './static/images/bathroom-background.jpg';
	}

	public init(): void {
		this.sceneElements.sceneContainer.style.display = 'block';

		this.timeouts.push(
			setTimeout(() => {
				this.audioPlayer.voiceOvers.waterFaucet.stop();
				this.audioPlayer.voiceOvers.lightSwitch.play();
				this.audioPlayer.soundFx.lightSwitchScene.energyDrone.play();
			}, 1500)
		);

		this.timeouts.push(
			setTimeout(() => {
				this.audioPlayer.soundFx.general.actionChime.play();
				this.sceneElements.lightSwitch.helperOverlay.classList.add('pulse');
			}, 4500)
		);

		this.timeouts.push(
			setTimeout(() => {
				this.actionHelper.showActionPrompt('69%', '36%');
			}, 7500)
		);

		this.timeouts.push(
			setTimeout(() => {
				this.sceneElements.lightSwitch.on.click();
			}, 12500)
		);

		this.listenForLightSwitchClicks();
	}

	public listenForLightSwitchClicks(): void {
		this.sceneElements.lightSwitch.on.addEventListener('click', () => {
			// Light switch scene audio
			this.audioPlayer.soundFx.lightSwitchScene.energyDrone.stop();
			this.audioPlayer.soundFx.lightSwitchScene.lightSwitchOff.play();

			this.fadeToBlack();
		});
	}

	public fadeToBlack(): void {
		this.sceneElements.lightSwitch.helperOverlay.classList.remove('pulse');
		this.actionHelper.hideActionPrompt();
		this.timeouts.forEach((timeout: any) => {
			clearTimeout(timeout);
		});

		this.sceneElements.lightSwitch.on.style.display = 'none';
		this.sceneElements.darkOverlay.classList.add('on');
		this.sceneElements.lightBulb.on.style.display = 'none';
		this.sceneElements.lightBulb.glow.style.display = 'none';

		this.sceneElements.secondFlowerContainer.style.display = 'block';

		setTimeout(() => {
			this.audioPlayer.soundFx.general.correctActionChime.play();
		}, 500);

		setTimeout(() => {
			this.sceneElements.darkOverlay.classList.remove('on');
			this.sceneElements.darkOverlay.classList.add('fade-to-black');
		}, 1000);

		setTimeout(() => {
			this.eventEmitter.dispatchEvent(new Event('finished'));
			this.audioPlayer.soundFx.lightSwitchScene.doorOpening.play();
			this.sceneElements.darkOverlay.classList.add('zoom-in');
			this.removeElements();
		}, 2000);

		setTimeout(() => {
			this.sceneElements.background.style.display = 'none';
			this.sceneElements.darkOverlay.classList.remove('fade-to-black');
		}, 3500);
	}

	private removeElements(): void {
		this.sceneElements.lightBulb.on.remove();
		this.sceneElements.lightBulb.off.remove();
		this.sceneElements.lightBulb.glow.remove();
		this.sceneElements.lightSwitch.on.remove();
		this.sceneElements.lightSwitch.off.remove();
		this.sceneElements.door.remove();
	}
}
